import _ from "lodash";

const initialState = {
  formId: -1,
  uuid: "",
  title: "",
  version: "",
  icon_path: null,
  errors: [],
  repeatingFormErrors: [],
  isLoading: [],
  approval_enabled: false,
  submitted: false,
  exists: true,
  postingStatus: false,
  submitting: false,
  validate: false,
  active_element: -1,
  data: [],
  draft: [],
  draftId: "",
  showMsg: false,
  showMsgRepeat: false,
  preview: "",
  lookup: [],
  mandatoryControls: [],
  repeatingFormValidate: false,
  repeatingFormId: -1,
  repeatingFormUUID: -1,
  repeatingFormIndex: -1,
  repeatingFormEdit: false,
  repeatingFormTitle: ""
};

const form = (state = initialState, action) => {
  switch (action.type) {
    case "RECEIVE_FORM_CONTROLS":
      return Object.assign({}, state, {
        data: action.formControls
      });
    case "UPDATE_PREVIEW":
      return Object.assign({}, state, {
        preview: action.preview
      });
    case "UPDATE_FORM_VERSION":
      return Object.assign({}, state, {
        version: action.form_version
      });
    case "UPDATE_FORM_VALIDATE":
      return Object.assign({}, state, {
        validate: action.value
      });
    case "UPDATE_REPEATING_FORM_VALIDATE":
      return Object.assign({}, state, {
        repeatingFormValidate: action.value
      });
    case "UPDATE_SHOW_MSG":
      return Object.assign({}, state, {
        showMsg: action.value
      });
    case "UPDATE_SHOW_MSG_REPEAT":
      return Object.assign({}, state, {
        showMsgRepeat: action.value
      });
    case "SET_WORKING_DRAFT":
      return Object.assign({}, state, {
        draft: action.draft,
        draftId: action.uuid
      });
    case "CLEAR_SECTION_MANDATORY":
      return {
        ...state,
        mandatoryControls: state.mandatoryControls.filter(
          c => c.section !== action.section
        )
      };
    case "SET_MANDATORY":
      return Object.assign({}, state, {
        mandatoryControls: [
          ...state.mandatoryControls,
          {
            section: action.section,
            element_id: action.element_id
          }
        ]
      });
    case "SET_REPEATING_FORM":
      return Object.assign({}, state, {
        repeatingFormId: action.value,
        repeatingFormIndex: action.index,
        repeatingFormUUID: action.repeatingFormUUID,
        repeatingFormEdit: action.edit,
        repeatingFormTitle: action.title
      });
    case "ADD_REPEATING_FORM":
      let eRepeatX = _.filter(state.draft, function(draft) {
        return draft.repeatingFormUUID === action.repeatingFormUUID;
      });

      var updatedDraft = [];
      let eElement = [];
      updatedDraft = eRepeatX.map(function(element) {
        if (element.repeatingFormEdit === false) {
          eElement = _.filter(state.draft, function(draft) {
            return (
              draft.repeatingFormEdit === true &&
              draft.repeatingFormUUID === action.repeatingFormUUID &&
              draft.element_id === element.element_id
            );
          });
          if (eElement.length > 0) {
            return {
              ...element,
              repeatingFormEdit: false,
              element_value: eElement[0].element_value
            };
          } else {
            return element;
          }
        } else {
          eElement = _.filter(state.draft, function(draft) {
            return (
              draft.repeatingFormEdit === false &&
              draft.repeatingFormUUID === action.repeatingFormUUID &&
              draft.element_id === element.element_id
            );
          });
          if (eElement.length > 0) {
            return { ...element, repeatingFormEdit: "remove" };
          } else {
            return { ...element, repeatingFormEdit: false };
          }
        }
      });

      eElement = _.filter(state.draft, function(draft) {
        return (
          draft.repeatingFormUUID !==
            (action.repeatingFormUUID === undefined
              ? -1
              : action.repeatingFormUUID) &&
          Number(draft.element_id) !== Number(state.repeatingFormId)
        );
      });

      updatedDraft = _.filter(updatedDraft, function(draft) {
        return draft.repeatingFormEdit !== "remove";
      });

      let newX = eElement.concat(updatedDraft);

      let countX = _.filter(newX, function(draft) {
        return draft.repeatingFormId === state.repeatingFormId;
      });

      let n = _(countX)
        .map("repeatingFormUUID")
        .uniq()
        .value()
        .length.toString();

      newX = [
        ...newX,
        {
          element_id: state.repeatingFormId,
          element_value: n
        }
      ];

      return Object.assign({}, state, {
        repeatingFormId: -1,
        repeatingFormValidate: false,
        validate: false,
        repeatingFormUUID: -1,
        draft: newX
      });

    case "DELETE_REPEATING_FORM":
      let eRepeat = _.filter(state.draft, function(draft) {
        return (
          draft.repeatingFormId === undefined ||
          (draft.repeatingFormId !== undefined &&
            Number(draft.repeatingFormId) !== Number(state.repeatingFormId)) ||
          (draft.repeatingFormId === state.repeatingFormId &&
            draft.repeatingFormUUID !== state.repeatingFormUUID)
        );
      });

      let countD = _.filter(eRepeat, function(draft) {
        return draft.repeatingFormId === state.repeatingFormId;
      });

      let ni = _(countD)
        .map("repeatingFormUUID")
        .uniq()
        .value()
        .length.toString();

      let r_replacedItemIndex = _.findIndex(eRepeat, function(rItem) {
        return rItem.element_id == state.repeatingFormId;
      });

      if (ni === "0") {
        eRepeat = [...eRepeat.slice(0, r_replacedItemIndex)];
      } else {
        eRepeat = [
          ...eRepeat.slice(0, r_replacedItemIndex),
          {
            element_id: state.repeatingFormId,
            element_value: ni
          },
          ...eRepeat.slice(r_replacedItemIndex + 1)
        ];
      }

      return Object.assign({}, state, {
        draft: eRepeat,
        repeatingFormId: -1,
        repeatingFormValidate: false,
        repeatingFormUUID: -1,
        repeatingFormEdit: false
      });
    case "CANCEL_REPEATING_FORM":
      let eDraft = [];
      if (state.repeatingFormEdit) {
        eDraft = _.filter(state.draft, function(draft) {
          return (
            draft.repeatingFormId === undefined ||
            (draft.repeatingFormId !== undefined &&
              Number(draft.repeatingFormId) !==
                Number(state.repeatingFormId)) ||
            (draft.repeatingFormId === state.repeatingFormId &&
              draft.repeatingFormEdit === false)
          );
        });

        return Object.assign({}, state, {
          draft: eDraft,
          repeatingFormId: -1,
          repeatingFormUUID: -1,
          repeatingFormEdit: false,
          repeatingFormTitle: ""
        });
      } else {
        eDraft = _.filter(state.draft, function(draft) {
          return (
            draft.repeatingFormId === undefined ||
            (draft.repeatingFormId !== undefined &&
              Number(draft.repeatingFormId) !==
                Number(state.repeatingFormId)) ||
            (draft.repeatingFormId === state.repeatingFormId &&
              draft.repeatingFormUUID !== state.repeatingFormUUID)
          );
        });

        return Object.assign({}, state, {
          draft: eDraft,
          repeatingFormId: -1,
          repeatingFormValidate: false,
          repeatingFormUUID: -1,
          repeatingFormTitle: ""
        });
      }
    case "SET_SUBMITTING":
      return Object.assign({}, state, {
        submitting: action.value
      });
    case "UPDATE_FORM_ERRORS":
      return Object.assign({}, state, {
        errors: action.value
      });

    case "REPEATING_FORM_VALIDATE":
      let repeatingFormErrors = [];

      let data = state.data.map(function(element) {
        if (action.controls.indexOf(element.element_id) > -1) {
          return element;
        }
      });

      var cd = _.filter(data, { element_optional: "0" });
      cd.forEach((control, index) => {
        let cdi = _.filter(state.draft, {
          element_id: Number(control.element_id),
          repeatingFormUUID: state.repeatingFormUUID
        });
        if (cdi.length > 1) {
          cdi = _.filter(cdi, { repeatingFormEdit: true })[0];
        } else {
          cdi = cdi[0];
        }

        var cdx = _.filter(state.mandatoryControls, function(item) {
          return (
            item.section.toString().indexOf("r") > -1 &&
            Number(item.element_id) === Number(control.element_id)
          );
        });

        if (cdx.length > 0) {
          if (cdi === undefined || cdi.element_value === "") {
            repeatingFormErrors.push({
              element_id: Number(control.element_id),
              required: true
            });
          } else {
            if (cdi.element_value === "") {
              repeatingFormErrors.push({
                element_id: Number(control.element_id),
                required: true
              });
            }
          }
        }
      });

      return Object.assign({}, state, {
        repeatingFormErrors: repeatingFormErrors
      });

    case "FORM_VALIDATE":
      let errors = [];

      state.mandatoryControls.forEach((control, index) => {
        let cdi = _.filter(state.draft, {
          element_id: Number(control.element_id)
        })[0];
        if (cdi === undefined || cdi.element_value === "") {
          errors.push({
            element_id: Number(control.element_id),
            required: true
          });
        } else {
          if (cdi.element_value === "") {
            errors.push({
              element_id: Number(control.element_id),
              required: true
            });
          }
        }
      });

      return Object.assign({}, state, {
        errors: errors
      });
    case "SET_CONTROL_LOADING":
      let c_element = _.filter(state.isLoading, {
        element_id: action.element_id
      });
      let c_replacedItemIndex = _.findIndex(state.isLoading, function(
        voteItem
      ) {
        return voteItem.element_id == action.element_id;
      });
      if (c_element.length === 1) {
        return Object.assign({}, state, {
          isLoading: [
            ...state.isLoading.slice(0, c_replacedItemIndex),
            {
              element_id: action.element_id,
              loading: action.value
            },
            ...state.isLoading.slice(c_replacedItemIndex + 1)
          ]
        });
      } else {
        return Object.assign({}, state, {
          isLoading: [
            ...state.isLoading,
            {
              element_id: action.element_id,
              loading: action.value
            }
          ]
        });
      }
    case "SAVED_FORM":
      if (action.error === null) {
        return Object.assign({}, state, {
          submitted: true
        });
      } else {
        return Object.assign({}, state, {
          submitted: false
        });
      }
    case "SET_POSTING_STATUS":
      return Object.assign({}, state, {
        postingStatus: action.value
      });
    case "RESET_FORM":
      return Object.assign({}, state, {
        data: [],
        lookup: [],
        draft: [],
        mandatoryControls: [],
        draftId: "",
        title: "",
        active_element: -1,
        version: "",
        errors: [],
        submitted: false,
        repeatingFormValidate: false,
        validate: false
      });
    case "UPDATE_FORM_EXISTS":
      return Object.assign({}, state, {
        exists: action.value
      });
    case "UPDATE_FORM_TITLE":
      return Object.assign({}, state, {
        title: action.form_title,
        version: action.form_version,
        icon_path: action.icon_path,
        formId: action.form_id,
        uuid: action.form_uuid,
        approval_enabled: action.approval_enabled
      });

    case "UPDATE_FORM_ELEMENT":
      let element = _.filter(state.draft, function(draft) {
        return (
          Number(draft.element_id) === Number(action.element_id) &&
          draft.repeatingFormId ===
            (action.repeatingFormId !== -1
              ? action.repeatingFormId
              : undefined) &&
          draft.repeatingFormUUID ===
            (action.repeatingFormUUID !== -1
              ? action.repeatingFormUUID
              : undefined) &&
          draft.repeatingFormEdit ===
            (draft.repeatingFormEdit === undefined
              ? undefined
              : state.repeatingFormEdit)
        );
      });
      let replacedItemIndex = _.findIndex(state.draft, function(draft) {
        return (
          Number(draft.element_id) == Number(action.element_id) &&
          draft.repeatingFormId ===
            (action.repeatingFormId !== -1
              ? action.repeatingFormId
              : undefined) &&
          draft.repeatingFormUUID ===
            (action.repeatingFormUUID !== -1
              ? action.repeatingFormUUID
              : undefined) &&
          draft.repeatingFormEdit ===
            (draft.repeatingFormEdit === undefined
              ? undefined
              : state.repeatingFormEdit)
        );
      });

      if (element.length === 1) {
        if (action.repeatingFormId !== -1) {
          return Object.assign({}, state, {
            active_element: action.secondary
              ? state.active_element
              : action.element_id,
            draft: [
              ...state.draft.slice(0, replacedItemIndex),
              {
                element_id: action.element_id,
                element_value: action.element_value,
                repeatingFormId: action.repeatingFormId,
                repeatingFormUUID: action.repeatingFormUUID,
                repeatingFormIndex: action.repeatingFormIndex,
                repeatingFormEdit: state.repeatingFormEdit
              },
              ...state.draft.slice(replacedItemIndex + 1)
            ]
          });
        } else {
          return Object.assign({}, state, {
            active_element: action.secondary
              ? state.active_element
              : action.element_id,
            draft: [
              ...state.draft.slice(0, replacedItemIndex),
              {
                element_id: action.element_id,
                element_value: action.element_value
              },
              ...state.draft.slice(replacedItemIndex + 1)
            ]
          });
        }
      } else {
        if (action.repeatingFormId !== -1) {
          return Object.assign({}, state, {
            active_element: action.secondary
              ? state.active_element
              : action.element_id,
            draft: [
              ...state.draft,
              {
                element_id: action.element_id,
                element_value: action.element_value,
                repeatingFormId: action.repeatingFormId,
                repeatingFormUUID: action.repeatingFormUUID,
                repeatingFormIndex: action.repeatingFormIndex,
                repeatingFormEdit: state.repeatingFormEdit
              }
            ]
          });
        } else {
          return Object.assign({}, state, {
            active_element: action.secondary
              ? state.active_element
              : action.element_id,
            draft: [
              ...state.draft,
              {
                element_id: action.element_id,
                element_value: action.element_value
              }
            ]
          });
        }
      }

    case "UPDATE_LOOKUP":
      let lookupElement = null;
      let replacedLookupIndex = -1;
      if (action.lookup.repeatingFormUUID !== undefined) {
        let parentId = action.lookup.parentId;
        let uuid = action.lookup.repeatingFormUUID;
        lookupElement = _.filter(state.lookup, function(item) {
          return (
            item.parentId === Number(parentId) &&
            item.repeatingFormUUID === uuid
          );
        });
        replacedLookupIndex = _.findIndex(state.lookup, function(lookupItem) {
          return (
            lookupItem.parentId == Number(parentId) &&
            lookupItem.repeatingFormUUID === uuid
          );
        });
      } else {
        lookupElement = _.filter(state.lookup, {
          parentId: action.lookup.parentId
        });
        replacedLookupIndex = _.findIndex(state.lookup, function(lookupItem) {
          return lookupItem.parentId == action.lookup.parentId;
        });
      }

      if (lookupElement.length === 1) {
        return Object.assign({}, state, {
          lookup: [
            ...state.lookup.slice(0, replacedLookupIndex),
            action.lookup,
            ...state.lookup.slice(replacedLookupIndex + 1)
          ]
        });
      } else {
        return Object.assign({}, state, {
          lookup: [...state.lookup, action.lookup]
        });
      }

    case "UPDATE_FORM_ELEMENT_IMAGE":
      let elementImg = _.filter(state.draft, function(draft) {
        return (
          Number(draft.element_id) === Number(action.element_id) &&
          draft.repeatingFormId ===
            (action.repeatingFormId !== -1
              ? action.repeatingFormId
              : undefined) &&
          draft.repeatingFormUUID ===
            (action.repeatingFormUUID !== -1
              ? action.repeatingFormUUID
              : undefined) &&
          draft.repeatingFormEdit ===
            (draft.repeatingFormEdit === undefined
              ? undefined
              : state.repeatingFormEdit)
        );
      });
      let replacedImgIndex = _.findIndex(state.draft, function(draft) {
        return (
          Number(draft.element_id) == Number(action.element_id) &&
          draft.repeatingFormId ===
            (action.repeatingFormId !== -1
              ? action.repeatingForm
              : undefined) &&
          draft.repeatingFormUUID ===
            (action.repeatingFormUUID !== -1
              ? action.repeatingFormUUID
              : undefined) &&
          draft.repeatingFormEdit ===
            (draft.repeatingFormEdit === undefined
              ? undefined
              : state.repeatingFormEdit)
        );
      });

      if (elementImg.length === 1) {
        if (action.repeatingFormId !== -1) {
          return Object.assign({}, state, {
            active_element: action.element_id,
            draft: [
              ...state.draft.slice(0, replacedImgIndex),
              {
                element_id: action.element_id,
                element_value: action.element_value,
                base64: action.base64,
                repeatingFormId: action.repeatingFormId,
                repeatingFormUUID: action.repeatingFormUUID,
                repeatingFormIndex: action.repeatingFormIndex,
                repeatingFormEdit: state.repeatingFormEdit
              },
              ...state.draft.slice(replacedImgIndex + 1)
            ]
          });
        } else {
          return Object.assign({}, state, {
            active_element: action.element_id,
            draft: [
              ...state.draft.slice(0, replacedImgIndex),
              {
                element_id: action.element_id,
                element_value: action.element_value,
                base64: action.base64
              },
              ...state.draft.slice(replacedImgIndex + 1)
            ]
          });
        }
      } else {
        if (action.repeatingFormId !== -1) {
          return Object.assign({}, state, {
            active_element: action.element_id,
            draft: [
              ...state.draft,
              {
                element_id: action.element_id,
                element_value: action.element_value,
                base64: action.base64,
                repeatingFormId: action.repeatingFormId,
                repeatingFormUUID: action.repeatingFormUUID,
                repeatingFormIndex: action.repeatingFormIndex,
                repeatingFormEdit: state.repeatingFormEdit
              }
            ]
          });
        } else {
          return Object.assign({}, state, {
            active_element: action.element_id,
            draft: [
              ...state.draft,
              {
                element_id: action.element_id,
                element_value: action.element_value,
                base64: action.base64
              }
            ]
          });
        }
      }
    default:
      return state;
  }
};

export default form;



// WEBPACK FOOTER //
// ./src/reducers/form.js